export function formatCurrency(
  price: number | undefined,
  currency: string,
  maximumFractionDigits = 0,
): string {
  if (price === undefined) return '-';

  const numberFormatter = new Intl.NumberFormat('sv-SE', {
    style: 'decimal',
    minimumFractionDigits: maximumFractionDigits,
    maximumFractionDigits,
  });

  try {
    return `${numberFormatter.format(price)} ${currency}`;
  } catch {
    return '-';
  }
}
